import { DialogContent, Grid, Typography } from "@mui/material";
import React from "react";
import convertCurrency, { convertIntMoney } from "src/helper/convertCurrency";
import useInventoryNoteDetail from "src/hooks/inventory/useInventoryNoteDetail";

export default function FinanceDetailDialog({ id, wHouseId }) {
  const { data: inventDetail, isLoading } = useInventoryNoteDetail(id, {
    warehouse: wHouseId,
  });

  return (
    <DialogContent>
      <Grid container>
        <Grid
          item
          xs={12 / 2}
          mb="12px"
        >
          <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
            Đối tượng:
          </Typography>
          <Typography>Đối tượng:</Typography>
        </Grid>
        <Grid
          item
          xs={12 / 2}
          mb="12px"
        >
          <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
            Tên nhân viên kinh doanh
          </Typography>
          <Typography>Đối tượng:</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          mb="12px"
        >
          <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
            Tên khách hàng:
          </Typography>
          <Typography>Đối tượng:</Typography>
        </Grid>
        <Grid
          item
          xs={12 / 2}
          mb="12px"
        >
          <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
            Số tiền cần thanh toán:
          </Typography>
          <Typography>đ{convertIntMoney(inventDetail?.data?.total)}</Typography>
          <Typography sx={{ fontStyle: "italic", fontWeight: "bold", fontSize: "12px" }}>
            ({convertCurrency(inventDetail?.data?.total)} đồng)
          </Typography>
        </Grid>
        <Grid
          item
          xs={12 / 2}
          mb="12px"
        >
          <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
            Số dư chưa gạt nợ:
          </Typography>
          <Typography>Đối tượng:</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          mb="12px"
        >
          <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
            Mã ĐH/ Mã phiếu chuyển kho:
          </Typography>
          <Typography>N/A</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          mb="12px"
        >
          <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
            Ghi chú:
          </Typography>
          <Typography>Ghi chú</Typography>
        </Grid>
      </Grid>
    </DialogContent>
  );
}
